import { StorageKey } from '../components/enums';

const getItem = (item: StorageKey) => {
  try {
    return window.localStorage.getItem(item) ?? '';
  } catch {
    return '';
  }
};

const saveItem = (item: StorageKey, value: string) => {
  try {
    window.localStorage.setItem(item, value);
  } catch {
    return;
  }
};

export const clearStorage = () => {
  try {
    window.localStorage.removeItem(StorageKey.Comment);
    window.localStorage.removeItem(StorageKey.Images);
    window.localStorage.removeItem(StorageKey.Reason);
  } catch {
    return;
  }
};

export const getComment = () => getItem(StorageKey.Comment);
export const getImages = () => getItem(StorageKey.Images);
export const getReason = () => getItem(StorageKey.Reason);

export const saveComment = (comment: string) => saveItem(StorageKey.Comment, comment);

export const saveImages = (images: string) => saveItem(StorageKey.Images, images);

export const saveReason = (reason: string) => saveItem(StorageKey.Reason, reason);
